import { useNavigate } from "react-router-dom"
import { Webhook, ExternalLink } from "lucide-react"
import { Button } from "@/components/ui/button"

export function WebhooksSettingsPage() {
  const navigate = useNavigate()

  return (
    <div className="space-y-6">
      <div>
        <h1 className="page-title">Webhooki</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Konfiguruj webhooki do automatycznego powiadamiania zewn\u0119trznych system\u00F3w o zdarzeniach w CRM.
        </p>
      </div>

      <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-border py-16">
        <div
          className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-blue-500/[0.08]"
        >
          <Webhook size={28} className="text-primary opacity-60" />
        </div>
        <p className="mb-4 max-w-sm text-center text-sm text-muted-foreground">
          Zarz\u0105dzaj webhookami z poziomu dedykowanego modu\u0142u.
        </p>
        <Button onClick={() => navigate("/webhooks")} className="gap-2">
          <ExternalLink size={14} />
          Przejd\u017A do webhook\u00F3w
        </Button>
      </div>
    </div>
  )
}
